define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class ExportService
     */
    function ExportService() {
        var self = this;

        /**
         * Display correct label according to different order's status
         * @param  {Object} order
         * @return {String}    status label to display
         */
        self.displayOrderStatus = function displayOrderStatus(order) {
            return order.isLost
                ? 'Perdue'
                : order.isCancelled && order.replacedBy
                    ? 'Annulé / Remplacé'
                    : order.isCancelled
                        ? 'Annulé'
                        : order.isSigned
                            ? 'Signé'
                            : 'Non signé';
        };

        return self;
    }

    ExportService.$inject = [];

    angular.module('app.bdc.reports.exportService', []).factory('exportService', ExportService);
});
